import React, { HTMLAttributes } from 'react';
import LinkComponent from '../Link';

interface LinkProps extends HTMLAttributes<HTMLElement> {
  title: string;
  path: string;
}

export function Link({ title, path, ...props }: LinkProps) {
  return (
    <LinkComponent href={path} {...props}>
      {title}
    </LinkComponent>
  );
}
